function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();}function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}(function () {
  'use strict';PaypalButtonCtrl.$inject = ["$window", "$cookies", "$element", "$scope", "$http", "$localStorage", "$log", "$q", "$timeout", "$document", "$ocLazyLoad"];

  require('./paypal.scss');

  //angular.module('gplans.store').
  angular.module('gplans.dashboard').
  component('ggPaypalButton', {
    template: require('./paypal.html'),
    controller: PaypalButtonCtrl,
    controllerAs: 'vm',
    bindings: {
      tokenRequest: '&',
      success: '&' } });



  var depsPromise;
  var loadingError = false;
  var lastRequestWasAt;
  var requestInterval = 3000;

  PaypalButtonCtrl.$inject = [
  '$window',
  '$cookies',
  '$element',
  '$scope',
  '$http',
  '$localStorage',
  '$log',
  '$q',
  '$timeout',
  '$document',
  '$ocLazyLoad'];



  function PaypalButtonCtrl(
  $window,
  $cookies,
  $element,
  $scope,
  $http,
  $localStorage,
  $log,
  $q,
  $timeout,
  $document,
  $ocLazyLoad)
  {

    var vm = this;

    vm.loaded = false;
    vm.loadingError = false;

    if (!depsPromise ||
    loadingError && Date.now() - lastRequestWasAt > requestInterval)
    {
      lastRequestWasAt = Date.now();
      depsPromise = $q.all([
      getConfig(),
      getPaypalScript()]);

    }

    depsPromise.
    then(function (_ref) {var _ref2 = _slicedToArray(_ref, 2),config = _ref2[0],paypal = _ref2[1];return configure(config);}).
    then(function () {
      log('loaded');
      loadingError = false;
      vm.loaded = true;
    }).
    catch(function (err) {
      log('loading error');
      console.warn(err);
      loadingError = vm.loadingError = true;
    });


    function log(msg) {
      $log.log("PayPal ctrl # ".concat($scope.$id, " ").concat(msg));
    }

    function getPaypalScript() {

      var PAYPAL_SCRIPT_URL = 'https://www.paypalobjects.com/api/checkout.js';

      return $ocLazyLoad.load(PAYPAL_SCRIPT_URL).
      then(function (loadedComponents) {return $window.paypal;});
    }

    function getConfig() {
      if ($localStorage['paypalConfig']) {
        var deferred = $q.defer();
        deferred.resolve($localStorage['paypalConfig']);
        return deferred.promise;
      }
      return $http({
        url: gplansConf.API_URL + '/api/v1/paypal/config/',
        method: 'GET' }).
      then(function (response) {
        $localStorage['paypalConfig'] = response.data;
        return response.data;
      });
    }

    function payment() {
      var request = vm.tokenRequest();
      var csrftoken = $cookies.get('csrftoken');
      if (csrftoken) {
        request.headers = {
          'X-CSRFToken': csrftoken };

      }
      return $window.paypal.request(request).then(function (data) {
        return data.token;
      });
    }

    function onAuthorize(data, actions) {
      // Execute the payment here
      log('success');
      vm.success({ response: data });
    }

    function configure(config) {
      log('configure');
      var client = {};
      var mode = config.mode === 'sandbox' ? 'sandbox' : 'production';

      client[mode] = config.client_id;

      vm.opts = {
        client: client,
        env: mode,
        style: {
          size: 'medium',
          color: 'gold',
          shape: 'pill',
          label: 'checkout' },

        commit: true,
        payment: payment,
        onAuthorize: onAuthorize };

    }

  }

})();